import { render, staticRenderFns } from "./CoordinationEventConfirmTable.vue?vue&type=template&id=4f523c23&scoped=true"
import script from "./CoordinationEventConfirmTable.vue?vue&type=script&lang=ts"
export * from "./CoordinationEventConfirmTable.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationEventConfirmTable.vue?vue&type=style&index=0&id=4f523c23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f523c23",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/coordination/event/coordination-event-confirm-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fcoordination%2Fevent%2FCoordinationEventConfirmTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports